/* eslint-disable import/no-anonymous-default-export */

// Estados brasileiros
const EBrazilStates = {
  AC: { code: 'AC', description: 'Acre' },
  AL: { code: 'AL', description: 'Alagoas' },
  AP: { code: 'AP', description: 'Amapá' },
  AM: { code: 'AM', description: 'Amazonas' },
  BA: { code: 'BA', description: 'Bahia' },
  CE: { code: 'CE', description: 'Ceará' },
  DF: { code: 'DF', description: 'Distrito Federal' },
  ES: { code: 'ES', description: 'Espírito Santo' },
  GO: { code: 'GO', description: 'Goiás' },
  MA: { code: 'MA', description: 'Maranhão' },
  MT: { code: 'MT', description: 'Mato Grosso' },
  MS: { code: 'MS', description: 'Mato Grosso do Sul' },
  MG: { code: 'MG', description: 'Minas Gerais' },
  PA: { code: 'PA', description: 'Pará' },
  PB: { code: 'PB', description: 'Paraíba' },
  PR: { code: 'PR', description: 'Paraná' },
  PE: { code: 'PE', description: 'Pernambuco' },
  PI: { code: 'PI', description: 'Piauí' },
  RJ: { code: 'RJ', description: 'Rio de Janeiro' },
  RN: { code: 'RN', description: 'Rio Grande do Norte' },
  RS: { code: 'RS', description: 'Rio Grande do Sul' },
  RO: { code: 'RO', description: 'Rondônia' },
  RR: { code: 'RR', description: 'Roraima' },
  SC: { code: 'SC', description: 'Santa Catarina' },
  SP: { code: 'SP', description: 'São Paulo' },
  SE: { code: 'SE', description: 'Sergipe' },
  TO: { code: 'TO', description: 'Tocantins' },
};

export default EBrazilStates;

